import React from 'react';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import MyButton from '../components/MyButton';
import {navigationBack} from '../navigation/NavigationActions';
import Header from '../components/Header';

class UpgradeScreen extends React.PureComponent {

    reload = () => {
        window.location.reload();
    };

    render() {
        return (
            <div className='mainBg levelScreenWrapper noSelectAtAll'>
                <Header
                    onBackPress={() => this.props.goBack()}
                    title={this.props.t('upgrade:title')}
                />
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 15
                }}>
                    <div>
                        <p style={{marginBottom: 15, color: '#FFFFFF', textAlign: 'center'}}>{this.props.t('upgrade:description')}</p>
                        <MyButton
                            wrapperStyles={{textAlign: 'center'}}
                            onPressButton={() => this.reload()}
                            title={this.props.t('upgrade:reload')}
                            loading={false}
                            size='large'
                            style={{backgroundColor: 'white', color: '#029EE9'}}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


/*const mapStateToProps = (state) => {
 return {
 user: state.auth.user,
 loadingLevelFailed: state.loadingLevelFailed,
 isLoading: state.levelLoading,
 };
 };*/

const mapDispatchToProps = (dispatch) => {
    return {
        goBack: () => dispatch(navigationBack()),
    };
};

export default connect(
    null,
    mapDispatchToProps
)(translate(['upgrade', 'common'])(UpgradeScreen));



// WEBPACK FOOTER //
// ./src/upgrade/UpgradeScreen.js